module.exports = "/_next/static/images/AIAnnouncements@2x-1f08e27856b360277b885f43b9d35193.png";